import * as Sentry from '@sentry/react';
import { ENVIRONMENT, GIT_INFO } from './config';
import { CaptureConsole } from '@sentry/integrations';

export const initSentry = () => {
  if (ENVIRONMENT === 'development') {
    return;
  }

  Sentry.init({
    dsn: 'https://8074f3bc515f48c585b38b62e2cc01ef@o1002609.ingest.sentry.io/4505431088955392',
    integrations: [
      new Sentry.BrowserTracing({
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [window.location.origin],
      }),
      new Sentry.Replay(),
      // @ts-ignore
      new CaptureConsole({ levels: ['error'] }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: ENVIRONMENT,
    release: GIT_INFO,
  });
};
